import Route from "./route";

export default class FlightRoute extends Route {
  constructor() {
    super();
    this.start_airport_code = "";
    this.end_airport_code = "";
  }

  loadFromApiData(apiData) {
    super.loadFromApiData(apiData);
    this.start_airport_code = apiData.departure_airport_code;
    this.end_airport_code = apiData.arrival_airport_code;
    this.start_place_name = apiData.departure_airport_name;
    this.end_place_name = apiData.arrival_airport_name;
  }
}
